import React from 'react';
import {PhotoSwipeGallery} from 'react-photoswipe';
import "./styles/photoswipe.css"
import "./styles/default-skin/default-skin.css"

class SwipePhoto extends React.Component {
    render() {
        let PHOTO_ITEMS = [];

        this.props.images.map((img) => {
            return PHOTO_ITEMS.push({
                src: img.full,
                w: img.width,
                h: img.height,
            })
        });
        let handleClose = () => {
            window.scrollBy(1000, 0);
        };

        let getThumbnailContent = (item) => {
            return (
                <img alt={''} src={item.src}/>
            );
        };

        let options = {
            history: false
        };

        return (
            <div className={'col--12'}>
                <PhotoSwipeGallery options={options} onClose={handleClose} items={PHOTO_ITEMS}
                                   thumbnailContent={getThumbnailContent}/>
            </div>
        )
    }
}

export default SwipePhoto